import classNames from 'classnames';
import { useRef, useEffect, useMemo, useState } from 'react';

export const DynamicInput = ({ 
    value, 
    onInput, 
    className = '', 
    targetWord = '',
    ...props 
}) => {
    const inputRef = useRef(null);
    const tempInputRef = useRef(null);
    
    // Функция для расчета ширины инпута в зависимости от текста в нем
    const calculateTextWidth = (text) => {
        if (!text || !inputRef.current) return 0;
        
        // Создаем временный input
        if (!tempInputRef.current) {
            tempInputRef.current = document.createElement('input');
            tempInputRef.current.style.position = 'absolute';
            tempInputRef.current.style.visibility = 'hidden';
            tempInputRef.current.style.width = '5px';
            document.body.appendChild(tempInputRef.current);
        }
        
        const tempInput = tempInputRef.current;

        tempInput.className = className;
        // или можно будет сделать такое копирование классов и стилей, если этого будет не достаточно
        // const originalInput = inputRef.current;

        // const computedStyle = window.getComputedStyle(originalInput);
        // tempInput.style.font = computedStyle.font;
        // tempInput.style.fontFamily = computedStyle.fontFamily;
        // tempInput.style.fontSize = computedStyle.fontSize;
        // tempInput.style.fontWeight = computedStyle.fontWeight;
        // tempInput.style.letterSpacing = computedStyle.letterSpacing;
        // tempInput.style.padding = computedStyle.padding;
        // tempInput.style.border = computedStyle.border;
        // tempInput.style.boxSizing = computedStyle.boxSizing;

        // tempInput.className = originalInput.className;

        tempInput.value = text;
        const textWidth = tempInput.scrollWidth;
        
        return textWidth;
    };
    
    const [isRefReady, setIsRefReady] = useState(false);
    
    useEffect(() => {
        if (inputRef.current) {
            setIsRefReady(true);
        }
    }, [inputRef.current]);

    // Автоматически подстраиваем ширину при изменении значения
    const calculatedWidth = useMemo(() => {
        if (!isRefReady) return 0;
        return calculateTextWidth(targetWord);
    }, [targetWord, isRefReady]);

    useEffect(() => {
        const initialWidth = calculatedWidth == 0 ? '50' : `${calculatedWidth + 15}`; //calculatedWidth будет 0 если не передан targetWord
        if (inputRef.current) {
            inputRef.current.style.width = `${initialWidth}px`;
            inputRef.current.style.width = `${Math.max(
                inputRef.current.scrollWidth + 10,
                calculatedWidth
            )}px`;
        }
    }, [value, calculatedWidth]);

    // Чистка при размонтировании
    useEffect(() => {
        return () => {
            if (tempInputRef.current) {
                document.body.removeChild(tempInputRef.current);
            }
        };
    }, []);

    return (
        <input
            {...props}
            ref={inputRef}
            className={classNames({[className]: !!className})}
            value={value}
            onInput={onInput}
        />
    );
};